import { render, staticRenderFns } from "./dept-selection.vue?vue&type=template&id=465833c3&scoped=true&"
import script from "./dept-selection.vue?vue&type=script&lang=js&"
export * from "./dept-selection.vue?vue&type=script&lang=js&"
import style0 from "./dept-selection.vue?vue&type=style&index=0&id=465833c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465833c3",
  null
  
)

export default component.exports